import Vue from 'vue'
import focus from './modules/focus.js'

Vue.directive('focus', focus)
